import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import WhiteBox from "@/components/WhiteBox.vue";
import Modal from "@/components/Modal.vue";
import UserList from "@/types/User/UserList";
let UsersEditor = class UsersEditor extends Vue {
    //intial load of the user.
    loadUsers() {
        this.$data.preloaded = false;
        this.$store
            .dispatch("getAllUsers")
            .then((result) => {
            this.$data.userList = new UserList(result.data);
            this.$data.preloaded = true;
        })
            .catch((err) => {
            window.errorHandler.logError(err, "UserEditor.vue -> loadUsers");
            this.$data.preloaded = true; //end loading on error
        });
    }
    //creates a new user
    createUser() {
        this.$data.loading = true;
        this.$store
            .dispatch("createNewUser", this.$data.newUser)
            .then((result) => {
            this.$data.loading = false;
            this.$data.modals.createUser = false; //close the modal
            this.loadUsers(); // reload the users
            this.$store.dispatch("ToastMessage", {
                type: "any",
                message: "The user has been created with id: " + result.data,
            });
        })
            .catch((err) => {
            window.errorHandler.logError(err, "UserEditor.vue -> createUser");
            this.$data.loading = false; //end loading on error
        });
    }
    //creates a new user
    updateUser() {
        this.$data.loading = true;
        this.$store
            .dispatch("editUser", this.$data.selectedUser)
            .then((result) => {
            this.$data.loading = false;
            this.$data.modals.editUser = false; //close the modal
            this.loadUsers(); // reload the users
            this.$store.dispatch("ToastMessage", {
                type: "any",
                message: "The user " +
                    this.$data.selectedUser.firstName +
                    " " +
                    this.$data.selectedUser.lastName +
                    " has been updated",
            });
        })
            .catch((err) => {
            window.errorHandler.logError(err, "UserEditor.vue -> updateUser");
            this.$data.loading = false; //end loading on error
        });
    }
    //creates a new user
    deleteUser() {
        this.$data.loading = true;
        this.$store
            .dispatch("deleteUser", this.$data.selectedUser)
            .then((result) => {
            this.$data.loading = false;
            this.$data.modals.deleteUser = false; //close the modal
            this.loadUsers(); // reload the users
            this.$store.dispatch("ToastMessage", {
                type: "any",
                message: "The user " +
                    this.$data.selectedUser.firstName +
                    " " +
                    this.$data.selectedUser.lastName +
                    " has been deleted",
            });
        })
            .catch((err) => {
            window.errorHandler.logError(err, "UserEditor.vue -> deleteUser");
            this.$data.loading = false; //end loading on error
        });
    }
    //shows the edit modal
    showEditModal(item) {
        this.$data.selectedUser = item; //sets the selected user before opening the edit modal
        this.$data.modals.editUser = true;
    }
    //shows the create modal
    showCreateModal() {
        this.$data.newUser = { email: "", firstName: "", lastName: "", teamId: "" };
        this.$data.modals.createUser = true;
    }
    //shows the delete user modal
    deleteUserModal(item) {
        this.$data.selectedUser = item;
        this.$data.modals.deleteUser = true;
    }
    //create an email based on the names
    generateEmail() {
        this.$data.newUser.email =
            this.$data.newUser.firstName +
                "." +
                this.$data.newUser.lastName +
                "@geshdo.com";
    }
};
UsersEditor = __decorate([
    Component({
        data() {
            return {
                theme: this.$store.getters.getTheme,
                filter: "",
                sortbyValue: "email",
                usersHeaders: [
                    { text: "First Name", value: "firstName" },
                    { text: "Last Name", value: "lastName" },
                    { text: "E-mail", value: "email" },
                    { text: "UserType", value: "userType" },
                    { text: "Edit", value: "edit", sortable: false },
                    { text: "", value: "delete", sortable: false },
                ],
                impersonateText: "Impersonate",
                //new
                userList: null,
                preloaded: false,
                loading: false,
                modals: { editUser: false, createUser: false, deleteUser: false },
                selectedUser: null,
                newUser: { email: "", firstName: "", lastName: "" },
            };
        },
        created() {
            this.loadUsers();
        },
        computed: {
            users() {
                return this.$data.userList.users;
            },
        },
        components: {
            WhiteBox,
            Modal,
        },
    })
], UsersEditor);
export default UsersEditor;
